import { render, staticRenderFns } from "./PresentationCollaborateList.vue?vue&type=template&id=99a5e630&scoped=true"
import script from "./PresentationCollaborateList.vue?vue&type=script&lang=js"
export * from "./PresentationCollaborateList.vue?vue&type=script&lang=js"
import style0 from "./PresentationCollaborateList.vue?vue&type=style&index=0&id=99a5e630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a5e630",
  null
  
)

export default component.exports